import "apps/pathways/styles/components/resume-download.scss";
import React from 'react';
import PropTypes from 'prop-types'
import Query from 'library/util/query';
import Ajax from 'axios';
import SavingButton from 'library/components/saving-button';
import { resolve, set } from 'library/helpers/path-resolver';
import Loading from 'library/components/loading';
import Notification, { Error as NotificationError } from 'library/components/notification';
import { GetUserData } from 'apps/pathways/services/pathway';

import Modal from 'library/helpers/modal';

const ProgressBar = ({ progress }) => {
  const RADIUS = 54;
  const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

  const dashoffset = CIRCUMFERENCE * ( 1 - progress );
  return (
    <svg className="circle-progress" width="120" height="120" viewBox="0 0 120 120">
      <circle className="circle-progress-meter" cx="60" cy="60" r="54" strokeWidth="12" />
      <circle className="circle-progress-value" strokeDasharray={CIRCUMFERENCE} strokeDashoffset={dashoffset} cx="60" cy="60" r="54" strokeWidth="12" />
      <text textAnchor="middle" fontSize="16" x="60" y="68">{ Math.floor(progress*100) }%</text>
    </svg>
  )
}

const formatResumeData = (account) => {
  return {
    filename: `${account.first_name} ${account.last_name} Resume`,
    first_name: account.first_name,
    last_name: account.last_name,
    email: account.email,
    phone: account.phone,
    street: account.street,
    street_2: account.street_2,
    state: account.state,
    zipcode: account.zipcode,
    city: account.city,
    qualities: account.most_recent_completed_assessment.qualities.map(v=>({
      name: v.name,
      link_name: v.link_name,
      description: v.description
    })),
    social: account.social.map(v=>({
      social_url: v.social_url,
      social_type: v.social_type
    })),
    certifications: account.certifications.map(v=>({
      name: v.name,
      institution: v.institution,
      description: v.description,
      date_range: v.date_range
    })),
    education_histories: account.education_histories.map(v=>({
      degree: v.degree,
      field_of_study: v.field_of_study,
      school: v.school,
      description: v.description,
      date_range: v.date_range
    })),
    work_histories: account.work_histories.map(v=>({
      title: v.title,
      company: v.company,
      description: v.description,
      date_range: v.date_range
    })),
    skills: account.skills.map(v=>({
      name: v.name,
      proficiency: v.proficiency
    })),
    languages: account.languages.map(v=>({
      name: v.name,
      proficiency: v.proficiency
    }))
  }
}

export default class ResumeDownload extends React.Component {
  static contextTypes = {
    user: PropTypes.object,
    updateUserValue: PropTypes.func
  }

  state = {
    loading: false
  }

  componentWillMount() {
    this.load();
  }

  load = async () => {
    this.setState({
      loading: false
    })

    this.setState({
      resumeUrl: await this.getResumeUrl(),
      loading: false
    });
  }

  getResumeUrl = async () => {
    const { data:{ account } } = await Query(`
      query {
        account {
          resume_url
        }
      }
    `);

    const resumeUrl = resolve(account, `resume_url`, null);
    return resumeUrl;
  }

  updateResumeUrl = async (url) => {
    Query(`
      mutation {
        update_account (input: {resume_url: "${url}"}) {
          success
          account {
            resume_url
          }
        }
      }
    `)
  }

  postResumeData = async (account) => {
    const data = await Ajax.post(`https://resumator.pairin.com/`, formatResumeData(account))
    const link = data.data.url
    this.updateResumeUrl(link)
    return link;
  }

  generateResume = async () => {
    this.setState({
      loading: true
    })
    try {
      const account = await GetUserData();
      const link = await this.postResumeData(account);

      window.open(link, '_blank_');
    } catch (e) {
      console.error(e);
      Notification.new(
          {timeout: 5000},
          <NotificationError>
              { e.toString() }
          </NotificationError>
      );
    }
    this.setState({
      loading: false
    })
  }

  render() {
    const resumeUrl = this.state.resumeUrl;

    if (resumeUrl) {
      return (
        <a href={resumeUrl} download="resume.pdf" className="button" {...this.props}>Download</a>
      )
    }

    return (
      <SavingButton {...this.props} saving={this.state.loading} onClick={this.generateResume}>Download</SavingButton>
    )
  }
}
